import React from 'react';
import { Link } from 'react-router-dom';
import './PageNotFound.css';

const PageNotFound = () => {
  const handleWhatsAppClick = () => {
    const message = encodeURIComponent(
      "Hello! I'm having trouble finding what I'm looking for on your website. Can you help me?"
    );
    window.open(`https://wa.me/923427374035?text=${message}`, '_blank');
  };

  return (
    <div className="page-not-found">
      <div className="container">
        <div className="error-content">
          <h1>404</h1>
          <h2>Page Not Found</h2>
          <p>The page you're looking for doesn't exist or has been moved.</p>
          <div className="action-buttons">
            <Link to="/" className="btn btn-primary">
              Return Home
            </Link>
            <Link to="/products" className="btn btn-secondary">
              View Products
            </Link>
            <button 
              className="btn btn-whatsapp"
              onClick={handleWhatsAppClick}
            >
              <span className="whatsapp-icon">
                <svg viewBox="0 0 24 24" width="18" height="18">
                  <path fill="currentColor" d="M12.031 6.172c-3.181 0-5.767 2.586-5.768 5.766-.001 1.298.38 2.27 1.019 3.287l-.582 2.128 2.182-.573c.978.58 1.911.928 3.145.929 3.178 0 5.767-2.587 5.768-5.766.001-3.187-2.575-5.77-5.764-5.771zm3.392 8.244c-.144.405-.837.774-1.17.824-.299.045-.677.063-1.092-.069-.252-.08-.575-.187-.988-.365-1.739-.751-2.874-2.502-2.961-2.617-.087-.116-.708-.94-.708-1.793s.448-1.273.607-1.446c.159-.173.346-.217.462-.217l.332.006c.106.005.249-.04.39.298.144.347.491 1.2.534 1.287.043.087.072.188.014.304-.058.116-.087.188-.173.289l-.26.304c-.087.086-.177.18-.076.354.101.174.449.741.964 1.201.662.591 1.221.774 1.394.86s.274.072.376-.043c.101-.116.433-.506.549-.68.116-.173.231-.145.39-.087s1.011.477 1.184.564c.173.087.289.129.332.202.043.073.043.423-.101.827z"/>
                </svg>
              </span>
              Need Help?
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageNotFound;
